

















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import BtnDefault from '@/components/UI/BtnDefault.vue';

const dialog = namespace('dialog')

@Component({
  name: "SurveyLimit",
  components: {
    BtnDefault
  }
})
export default class SurveyLimit extends Vue {
  @dialog.Mutation('SetFullPlanShow') protected SetFullPlanShow: any

  showPlans() {
    this.SetFullPlanShow(true)
  }

}
